import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-neon-green/25 bg-graphite/70 p-10 md:p-14">
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-neon-green/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-electric-blue/10 blur-3xl" />

          <p className="font-mono text-xs uppercase tracking-widest text-neon-green">/ ready to verify</p>
          <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
            Verify any GITSI certificate in <span className="text-neon-green">seconds</span>.
          </h2>
          <p className="mt-4 max-w-2xl text-base text-white/65">
            Every certificate carries a unique enrollment number and QR code. Recruiters
            and institutions can verify authenticity instantly.
          </p>
          <div className="mt-7">
            <Link to="/student-verification" data-testid="cta-verify-btn" className="btn-neon">
              <ShieldCheck size={18} className="mr-2" /> Verify Certificate Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
